import { render } from "./TrackingTagsCreate.vue?vue&type=template&id=3937a7eb&scoped=true"
import script from "./TrackingTagsCreate.vue?vue&type=script&lang=js"
export * from "./TrackingTagsCreate.vue?vue&type=script&lang=js"

import "./TrackingTagsCreate.vue?vue&type=style&index=0&id=3937a7eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3937a7eb"]])

export default __exports__